import toast from 'react-hot-toast';
import { call, takeEvery, put } from 'redux-saga/effects';
import { showToast } from 'helpers';
import { setApiStatus } from '../reducers/globals/globalActions';
import { store } from '../store';
import { RESTCallError, sendDeleteRequest } from './utils';

function deleteApi(apiName, url, body, extras) {
	console.log("🚀 ~ deleteApi ~ apiName, url, body, extras:", apiName, url, body, extras)
	return {
		type: 'DELETE_API_DATA',
		apiName: apiName,
		url: url,
		body: body,
		extras: extras,
	};
}

function* deleteApiDataSaga() {
	yield takeEvery('DELETE_API_DATA', deleteApiDataWorker);
}

function* deleteApiDataWorker(param) {
	let url = param.url;
	let apiName = param.apiName;
	try {
		store.dispatch(setApiStatus(apiName, 'PENDING'));

		const result = yield call(sendDeleteRequest, apiName, url, param.body);
		if (result?.status === 201 || result?.status === 200) {
			console.log('🚀 ~ file: deleteApiSaga.js:28 ~ function*deleteApiDataWorker ~ result:', result);
			yield deleteApiDataSuccess(result?.data, apiName, param.extras);
			// yield toast.error(result?.data?.message || 'Deleted!');
		} else if (result?.statusCode >= 400 && result?.statusCode < 500) {
			// Client error (400, 401, 403, 422, etc.) - distinguish auth from business errors
			const statusCode = result?.statusCode;
			const errorMessage = result?.error?.response?.data?.message || `Error: ${result?.error?.response?.statusText}`;
			
			if (statusCode === 401 || statusCode === 403) {
				// Auth failure - logout
				toast.error(errorMessage);
				RESTCallError(result, apiName);
			} else {
				// Business error (400, 422, etc.) - show toast but stay logged in
				toast.error(errorMessage);
				yield put(setApiStatus(apiName, 'FAILED'));
			}
		} else if (result?.statusCode >= 500) {
			// Server error - show toast but stay logged in
			const errorMessage = result?.error?.response?.data?.message || 'Server error. Please try again.';
			toast.error(errorMessage);
			yield put(setApiStatus(apiName, 'FAILED'));
		} else if (result?.status === 'Error') {
			// Network error or other exception
			toast.error('Network error. Please check your connection.');
			yield put(setApiStatus(apiName, 'FAILED'));
		}
	} catch (error) {
		console.log(param);
		console.log(error);
		console.log({ ...error });
	}
}

function* deleteApiDataSuccess(response, apiName, extras) {
	// toast.success('Deleted');
	// switch (apiName) {
	// 	case 'DELETE_PROJECT':
	// 		SuccessNotification('Success', 'Project Deleted');
	// 		break;

	// 	case 'DELETE_DOCUMENT':
	// 		SuccessNotification('Success', 'Document deleted');
	// 		break;

	// 	case 'DELETE_ITEM':
	// 		SuccessNotification('Success', 'Item Deleted');
	// 		break;
	// 	case 'DELETE_SUB_ITEM':
	// 		SuccessNotification('Success', 'Sub Item Deleted');
	// 		break;

	// 	case 'DELETE_CUSTOMER':
	// 		SuccessNotification('Success', 'Customer has Been Removed');
	// 		break;
	// 	case 'DELETE_SUPPLIER':
	// 		SuccessNotification('Success', 'Supplier has Been Removed');
	// 		break;
	// 	case 'DELETE_AGENT':
	// 		SuccessNotification('Success', 'Agent has Been Removed');
	// 		break;
	// 	case 'DELETE_INVOICE':
	// 		toast.success('Deleted');
	// 		break;
	// 	case 'DELETE_TICKET':
	// 		toast.success('Ticket has been deleted');
	// 		break;
	// 	case 'DELETE_DAILY_TRANSACTION':
	// 		SuccessNotification('Success', 'Daily Transaction has Been Removed');
	// 		break;
	// 	case 'DELETE_PRODUCTION':
	// 		SuccessNotification('Success', 'Production has Been Removed');
	// 		break;
	// 	case 'DELETE_ACC_BOOK':
	// 		SuccessNotification('Success', 'Account Book has Been Removed');
	// 		break;
	// 	case 'DELETE_VOUCHER':
	// 		SuccessNotification('Success', 'Voucher has Been Removed');
	// 		break;

	// 	default:
	// 		break;
	// }
	yield showToast("Success", "Deleted Successfully!!");
	yield put(setApiStatus(apiName, 'SUCCESS'));
}

export { deleteApi, deleteApiDataSaga };
